import { useDummyCart } from 'hooks/cart/useDummyCart';
import type { PromoCode } from 'types/cart/PromoCode';
import type { ProductBundle } from 'types/cms/blocks';

export const PRODUCT_BUNDLE_KEY = 'productBundle';

interface UseProductBundleOptions {
  _key: string;
  products?: ProductBundle['products'];
  promoCodes?: [PromoCode];
}

export const useProductBundle = ({
  _key,
  products,
  promoCodes,
}: UseProductBundleOptions) => {
  const key = PRODUCT_BUNDLE_KEY;
  const lines = products?.map((product) => ({
    merchandiseId: product.variant.gid,
  }));

  return useDummyCart({
    key,
    id: _key,
    lines,
    promoCodes,
  });
};
